import { render } from "./FullscreenModalHost.vue?vue&type=template&id=a1164f9a"
import script from "./FullscreenModalHost.vue?vue&type=script&lang=js"
export * from "./FullscreenModalHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/FullscreenModalHost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1164f9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1164f9a', __exports__)) {
    api.reload('a1164f9a', __exports__)
  }
  
  module.hot.accept("./FullscreenModalHost.vue?vue&type=template&id=a1164f9a", () => {
    api.rerender('a1164f9a', render)
  })

}


export default __exports__